var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69d7f9;}.cls-2{fill:none;stroke:#3a00ba;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.78,43.86S56,46.8,56,55.2V68.07h4.47v-14S60,43.86,47.78,43.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.67,16s7.75,1.2,7.75,8.62h4.25V19.09s.66-3.16-7.41-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.42,27.82V60.66h4.69V27.93S79.31,27.93,79.42,27.82Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.69,71.12V69.78a2.44,2.44,0,0,1,2.44-2.44h.61a2.44,2.44,0,0,1,2.44,2.44v2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.66,
    y: 71.74,
    width: 11.55,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.94,20.84v3.65H12.46V20.87a5.05,5.05,0,0,1,5.07-5.07H78.85A5.06,5.06,0,0,1,83.94,20.84Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.99,
    y1: 20.36,
    x2: 19.97,
    y2: 20.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.5,
    y1: 20.36,
    x2: 25.48,
    y2: 20.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.01,
    y1: 20.36,
    x2: 30.99,
    y2: 20.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.2,43.49h0A12.18,12.18,0,0,1,60.38,55.67V68.22a0,0,0,0,1,0,0H36a0,0,0,0,1,0,0V55.67A12.18,12.18,0,0,1,48.2,43.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.14,
    y1: 56.49,
    x2: 52.26,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.2,
    y1: 56.31,
    x2: 48.2,
    y2: 68.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.32,
    y1: 68.22,
    x2: 65.07,
    y2: 68.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.2,
    y1: 33.34,
    x2: 48.2,
    y2: 40.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.43,
    y1: 56.58,
    x2: 63.95,
    y2: 56.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.44,
    y1: 56.58,
    x2: 24.96,
    y2: 56.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.77,
    y1: 40.15,
    x2: 37.06,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.63,
    y1: 40.15,
    x2: 59.34,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.92,83.07,81,88.94a2.75,2.75,0,0,1-3.15,0L70,83.07a8.27,8.27,0,0,1-3-6.22V61.21h25V76.85A8.26,8.26,0,0,1,88.92,83.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.94,61.16V27.53H12.45V71.28A4.51,4.51,0,0,0,17,75.79H66.83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLine);
export default __webpack_public_path__ + "static/media/Alert_Line.46e438b8da40bd099ad8aad6ba351b78.svg";
export { ForwardRef as ReactComponent };